import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-09aef5ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "latest-swatches-wrap" }
const _hoisted_2 = ["onClick"]


const __default__ = {
  name: 'Latest'
}

import Color from 'color'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    historyColor: null
  },
  emits: ['update:color'],
  setup(__props: any, { emit }) {





const onColorSelect = (color: string) => {
  const value = Color(color)
  emit('update:color', value.hexa(), value.alpha())
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.historyColor, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: "color-item",
        onClick: ($event: any) => (onColorSelect(item))
      }, [
        _createElementVNode("div", {
          class: "color-item__dispaly",
          style: _normalizeStyle({ background: item })
        }, null, 4)
      ], 8, _hoisted_2))
    }), 128))
  ]))
}
}

})